// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__UKbST","modalFooterButton":"ModalNotes_modalFooterButton__2MxnM"};